export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DownloadFileLink.vue?vue&type=template&id=3e188d38&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/DownloadFileLink.vue?vue&type=template&id=3e188d38&scoped=true
// module id = 1569
// module chunks = 31